import { useContext, useEffect, useState } from "react";
import { DeviceDto } from "../../../../dtos/catalogs/Device/DeviceDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import DeviceDetailSkeleton from "./DeviceDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import DeviceDetailMain from "./DeviceDetailMain";

interface IProps {
  model: DeviceDto | null;
  modelUpdatedEvent: (newModel: DeviceDto) => void;
}

interface DeviceDetailModel {
  id: string;
  name: string;
  uniqueCode?: string;
  createdDate: Date;
  deviceType?: number;
  driverId?: string;
  userId?: string;
  serialNumber?: string;
}

export const DeviceDetail = ({ model }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<DeviceDetailModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("deviceType", model.deviceType);
      setValue("driverId", model.driverId);
      setValue("userId", model.userId);
      setValue("serialNumber", model.serialNumber);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: DeviceDetailModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    if (action === "save") {
      const newModel: DeviceDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <DeviceDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <DeviceDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
